import { Dispatch } from "redux";
import { fetchDocuments } from "../..";
import { Document } from "../../../../../../";
import { ApiConfig } from "../../../../../../config";

export const processAddRelatedResponse = (config: ApiConfig, dispatch: Dispatch) => (linkId: string) => (result: Document[]): Document[] => {
    // dispatch<any>(fetchDocuments(config)([linkId]))
    return result
}